interface DeliveryType {
  name: string;
  selected: boolean;
  disabled: boolean;
  value: any;
  key: string;
}

export interface IDeliveryTypesData {
  name: string;
  value: string;
  type: string;
  filter: string;
  controls: string[];
  controls_legal: string[];
}

export const DeliveryTypesData = [
  {
    name: 'TO_SUBSCRIBER_ADDRESS',
    value: 'address',
    type: 'cost_with_delivery',
    filter: 'paper',
    controls: ['address'],
    controls_legal: ['address', 'legal_info'],
  },
  {
    name: 'SUBSCRIPTION_BOX',
    value: 'ops_box',
    type: 'cost',
    filter: 'paper',
    controls: ['opsBox', 'ops_box_number'],
    controls_legal: ['opsBox', 'ops_box_number'],
  },
  {
    name: 'POSTE_RESTANTE',
    value: 'ops',
    type: 'cost',
    filter: 'paper',
    controls: ['ops'],
    controls_legal: ['ops'],
  },
  {
    name: 'virtual',
    value: 'virtual',
    type: 'cost_with_delivery',
    filter: 'virtual',
    controls: [],
    controls_legal: [],
  },
];

export class DeliveryTypes {
  private static readonly month: DeliveryType[] = [
    {
      name: 'SHORT_JANUARY',
      selected: false,
      disabled: false,
      value: [1],
      key: '1',
    },
    {
      name: 'SHORT_FEBRUARY',
      selected: false,
      disabled: false,
      value: [2],
      key: '2',
    },
    {
      name: 'SHORT_MARCH',
      selected: false,
      disabled: false,
      value: [3],
      key: '3',
    },
    {
      name: 'SHORT_APRIL',
      selected: false,
      disabled: false,
      value: [4],
      key: '4',
    },
    {
      name: 'SHORT_MAY',
      selected: false,
      disabled: false,
      value: [5],
      key: '5',
    },
    {
      name: 'SHORT_JUNE',
      selected: false,
      disabled: false,
      value: [6],
      key: '6',
    },
    {
      name: 'SHORT_JULY',
      selected: false,
      disabled: false,
      value: [7],
      key: '7',
    },
    {
      name: 'SHORT_AUGUST',
      selected: false,
      disabled: false,
      value: [8],
      key: '8',
    },
    {
      name: 'SHORT_SEPTEMBER',
      selected: false,
      disabled: false,
      value: [9],
      key: '9',
    },
    {
      name: 'SHORT_OCTOBER',
      selected: false,
      disabled: false,
      value: [10],
      key: '10',
    },
    {
      name: 'SHORT_NOVEMBER',
      selected: false,
      disabled: false,
      value: [11],
      key: '11',
    },
    {
      name: 'SHORT_DESEMBER',
      selected: false,
      disabled: false,
      value: [12],
      key: '12',
    },
  ];

  private static readonly dobleMont: DeliveryType[] = [
    {
      name: 'SHORT_JANUARY_AND_SHORT_FEBRUARY',
      selected: false,
      disabled: false,
      value: [1, 2],
      key: '1_2',
    },
    {
      name: 'SHORT_MARCH_AND_SHORT_APRIL',
      selected: false,
      disabled: false,
      value: [3, 4],
      key: '3_4',
    },
    {
      name: 'SHORT_MAY_AND_SHORT_JUNE',
      selected: false,
      disabled: false,
      value: [5, 6],
      key: '5_6',
    },
    {
      name: 'SHORT_JULY_AND_SHORT_AUGUST',
      selected: false,
      disabled: false,
      value: [7, 8],
      key: '7_8',
    },
    {
      name: 'SHORT_SEPTEMBER_AND_SHORT_OCTOBER',
      selected: false,
      disabled: false,
      value: [9, 10],
      key: '9_10',
    },
    {
      name: 'SHORT_NOVEMBER_AND_SHORT_DESEMBER',
      selected: false,
      disabled: false,
      value: [11, 12],
      key: '11_12',
    },
  ];

  private static readonly decade: DeliveryType[] = [
    {
      name: 'FIRST_DECADE',
      selected: false,
      disabled: false,
      value: [1, 2, 3],
      key: '1_2_3',
    },
    {
      name: 'SECOND_DECADE',
      selected: false,
      disabled: false,
      value: [4, 5, 6],
      key: '4_5_6',
    },
    {
      name: 'THIRD_DECADE',
      selected: false,
      disabled: false,
      value: [7, 8, 9],
      key: '7_8_9',
    },
    {
      name: 'FOURTH_DECADE',
      selected: false,
      disabled: false,
      value: [10, 11, 12],
      key: '10_11_12',
    },
  ];

  private static readonly year: DeliveryType[] = [
    {
      name: 'HALF_YEAR',
      selected: false,
      disabled: false,
      value: [1, 2, 3, 4, 5, 6],
      key: '1_2_3_4_5_6',
    },
    {
      name: 'HALF_YEAR',
      selected: false,
      disabled: false,
      value: [7, 8, 9, 10, 11, 12],
      key: '7_8_9_10_11_12',
    },
  ];

  private static get firstHalfYearMonth(): DeliveryType[] {
    return this.removeLink(this.month.slice(0, this.month.length / 2));
  }

  public static get firstHalfYearDobleMonth(): DeliveryType[] {
    return this.removeLink(this.dobleMont.slice(0, this.dobleMont.length / 2));
  }
  public static get firstHalfYearDecade(): DeliveryType[] {
    return this.removeLink(this.decade.slice(0, this.decade.length / 2));
  }
  public static get firstHalfYearYear(): DeliveryType[] {
    return this.removeLink(this.year.slice(0, this.year.length / 2));
  }
  public static get secondHalfYearMonth(): DeliveryType[] {
    return this.removeLink(this.month.slice(this.month.length / 2));
  }
  public static get secondHalfYearDobleMonth(): DeliveryType[] {
    return this.removeLink(this.dobleMont.slice(this.dobleMont.length / 2));
  }
  public static get secondHalfYearDecade(): DeliveryType[] {
    return this.removeLink(this.decade.slice(this.decade.length / 2));
  }
  public static get secondHalfYearYear(): DeliveryType[] {
    return this.removeLink(this.year.slice(this.year.length / 2));
  }

  private static removeLink(item) {
    return JSON.parse(JSON.stringify(item));
  }
}
